/**
 * Version of the privacy notice the registration form refers to, stored with each consent
 * (`clienti.consensoPrivacy.versione`). Bump it whenever the notice changes.
 */
export const VERSIONE_PRIVACY = 'bozza-2026-10'

/**
 * Version of the terms of sale accepted at checkout, stored with each order
 * (`ordini.consensi.condizioniVendita.versione`). Bump it whenever the terms change.
 */
export const VERSIONE_CONDIZIONI = 'bozza-2026-10'

/** Minimum password length, checked by the forms and the server actions. */
export const PASSWORD_MIN = 8
